import script from "./User.vue?vue&type=script&setup=true&lang=js"
export * from "./User.vue?vue&type=script&setup=true&lang=js"

import "./User.vue?vue&type=style&index=0&id=7a4d092e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a4d092e"]])

export default __exports__